import {
    Component,
    EventEmitter,
    Input,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { WipService } from 'app/modules/well-integrity-planning/services/wip.service';
import {
    WIPType,
} from 'app/modules/well-integrity-planning/model';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import module from 'app/modules/well-integrity-planning/well-integrity-planning.module';
import { ApplySortPayload } from 'app/core/shared/component/sort-menu/sort-menu.component';

@Component({
    selector: 'app-wip-datatable',
    templateUrl: './wip-datatable.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: module,
    styleUrls: ['./wip-datatable.component.scss'],
})
export class WIPDatatableComponent {
    @Input() onPage: any;
    @Input() searchForm: UntypedFormGroup;
    @Input() dt: any;
    @Input() wipType: any;
    @Input() downloadPath: { excel: string };
    @Input() sortInfo: string;
    @Input() columnSort: {};


    @Output() setPage = new EventEmitter<any>();
    @Output() resetPage = new EventEmitter<any>();
    @Output() addRecord = new EventEmitter<any>();

    constructor(
        private service: WipService,
        private _formBuilder: UntypedFormBuilder
    ) { }

    get canCreate() {
        return [WIPType.adhoc, WIPType.other].includes(this.wipType);
    }

    downloadExcel() {
        this.service.downloadExcel(this.downloadPath.excel, this.wipType);
    }

    onSearch() {
        return this._formBuilder.group({
            Page: [0],
            PageSize: [10],
            OrderBy: [null],
            OrderDir: [null],
            WellName: [''],
            PlatformName: [''],
            StringName: [''],
            FieldName: [''],
        });
    }

    formDialog(payload = null) {
        this.addRecord.emit(payload)
    }

    page(event: any) {
        this.setPage.emit(event);
    }

    reset(){
        this.resetPage.emit(); 
    }

    handleSearch(event$) {
        const field = event$?.Field;
        const platform = event$?.Platform;
        const well = event$?.Well;
        const string = event$?.String;
    
        if ([field, platform, well, string].some(v => v != null && v !== '')) {
          this.page({ offset: 0 });
        }
    }

    applySort(payload: ApplySortPayload) {
        // Patch form (fill missing with null)
        const [OrderBy1, OrderBy2, OrderBy3] = [
          payload.columns[0]?.key ?? null,
          payload.columns[1]?.key ?? null,
          payload.columns[2]?.key ?? null,
        ];
    
        this.searchForm.patchValue({
          OrderBy1,
          OrderBy2,
          OrderBy3,
          OrderDir: payload.orderDir ?? 'asc',
        });
        
        const labels = payload.columns.map(k => k.name);
        this.sortInfo = labels.length ? labels.join(' → ') : 'No sorting';
        this.page({ offset: 0 });
      }
}
